<template>
  <div class="modal fade" id="deletePhoneModal" tabindex="-1" aria-labelledby="deletePhoneModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 id="deletePhoneModalLabel" class="modal-title">Delete Phone</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            @click.prevent="resetForm"></button>
        </div>
        <div class="modal-body">
          Are you sure you want to delete extension
          <b>{{ selectedPhone.phone }} </b> from {{ selectedPhone.department }}?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click.prevent="resetForm">
            Close
          </button>
          <button type="button" class="btn btn-danger" @click.prevent="deletePhone">
            Delete Phone
            <loader :isLoading="isLoading"></loader>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import loader from "./loader";
import { Modal } from "bootstrap";
import { getters, mutations } from "../store";
export default {
  data() {
    return {
      modal: null,
      isLoading: false,
    };
  },
  components: {
    loader,
  },
  mounted() {
    this.modal = new Modal(document.getElementById("deletePhoneModal"));
  },
  computed: {
    selectedPhone() {
      return getters.selectedPhone();
    },
  },
  methods: {
    deletePhone() {
      this.isLoading = true;
      this.$axios
        .delete("/phones/" + this.selectedPhone._id, {})
        .then(({ data: { success, message } }) => {
          this.modal.hide();
          window.scrollTo(0, 0);
          this.isLoading = false;
          if (success) {
            mutations.deletePhone(this.selectedPhone);
          }
          this.resetForm();
          mutations.showToast({ success, message });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    showModal() {
      this.modal.show();
    },
    resetForm() {
      mutations.selectPhone();
    },
  },
};
</script>